import React from "react";
import styled, { keyframes } from "styled-components";

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0 10px;
  background-color: transparent;
  position: absolute;
  top: -35px;
  margin: auto;
  right: 50%;
  left: 50%;
`;

const Dots = styled.div`
  display: flex;
  gap: 6px;
`;

const Dot = styled.div<{ delay: number }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #8e8ea0;

  animation: ${bounce} 1.4s infinite ease-in-out;
  animation-delay: ${({ delay }) => delay}s;
`;

export const LoadingIndicator = () => {
  return (
    <Wrapper>
      <Dots>
        <Dot delay={0} />
        <Dot delay={0.15} />
        <Dot delay={0.3} />
      </Dots>
    </Wrapper>
  );
};
